import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit  {
  title = 'sadan-web-payment';
  currentLanguage: string = 'ar';
  direction: string = 'rtl'

  constructor(private translate: TranslateService) {

    translate.setDefaultLang('ar');
    this.translate.onLangChange.subscribe(data => {
      if (data.lang == 'ar') {
        this.currentLanguage = 'ar';
        this.direction = 'rtl'
      } else {
        this.currentLanguage = 'en';
        this.direction = 'ltr'
      }
    })
  }

  ngOnInit() {
    //
  }
}



